import CartObserver from 'UTILS/cart/CartObserver';

// we can safely init the cart in any file and be sure it is the same instance in all files
// because the CartObserver is a Singleton.
const cart = new CartObserver();
let btnEls;

function quickAddToCart(e) {
  const data = e.target.dataset;
  const payload = {
    id: parseInt(data.variantId, 10),
    quantity: parseInt(data.variantQuantity, 10),
  };
  cart.addToCart(payload);
}

// update the quick add button data when other colors are selected
// this ensures the correct variant id are swapped on the button dataset
function updateVariantQuickAdd(e) {
  const el = e.target;
  const data = el.dataset;
  const { variantIds } = data;
  const variants = JSON.parse(variantIds);
  const wrapper = el.closest('.ProductCard-wrapper');
  if (!wrapper) return;
  const btns = wrapper.querySelectorAll('.QuickAdd-button');
  btns.forEach((btn, i) => {
    const btnData = btn.dataset;
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(variants[i])) {
      if (btnData.optionName === key) {
        // eslint-disable-next-line no-param-reassign
        btn.dataset.variantId = value;
      }
    }
  });
}

function initBoostCollection({ quickAdd, swatches }) {
  quickAdd.forEach((btn) => {
    btn.removeEventListener('click', quickAddToCart, true);
    btn.addEventListener('click', quickAddToCart, true);
  });
  swatches.forEach((swatch) => {
    swatch.removeEventListener('mouseover', updateVariantQuickAdd, true);
    swatch.addEventListener('mouseover', updateVariantQuickAdd, true);
  });

  btnEls = quickAdd;
}

function disableAdd() {
  if (btnEls) {
    btnEls.forEach((btn) => {
      // eslint-disable-next-line no-param-reassign
      btn.disabled = true;
    });
  }
}

function enableAdd() {
  if (btnEls) {
    btnEls.forEach((btn) => {
      // eslint-disable-next-line no-param-reassign
      btn.disabled = false;
    });
  }
}

// don't allow the customer to add more to cart while cart is updating
cart.subscribe('beforeUpdate', disableAdd);
cart.subscribe('afterUpdate', enableAdd);
cart.subscribe('error', enableAdd);

window.TASC_BOOST_COLLECTION = {
  init: initBoostCollection,
};
